import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'pointer-events-none fixed inset-0 z-(--app-loading-indicator-z-index) cursor-wait select-none ' +
            'bg-(--app-loading-indicator-backdrop)',
        indicator:
            'absolute top-1/2 left-1/2 flex size-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center ' +
            'rounded-full border border-(--white-alpha-18) bg-(--glass-surface-bg-78) ' +
            'shadow-[0_0.75rem_2rem_rgba(15,23,42,0.2),0_0.25rem_0.75rem_rgba(15,23,42,0.14),inset_0_0.063rem_0_rgba(255,255,255,0.7)]',
        spinner:
            'size-7 animate-spin rounded-full border-[0.188rem] border-(--glass-chip-border) ' +
            'border-t-(--accent-solid)'
    }
} satisfies ComponentTheme;
